import React from 'react';
import {Text} from 'components/tt-forms/common';
import moment from 'moment';
import DataTable from 'components/data-table';
import { header } from 'constants/table';
import {
  RowItemListAttachReceptionPeriodical
} from 'modules/reception-periodical/datatable/detail';

class ThongTinCoQuanDaGiaiQuyet extends React.Component {
  
  render() {

    return (
      <div className="box-forward">
        <div className="container-box">
          <div className="group-box">
            <div className="title">
              <div className="rows mt20">
                <div className="col-12">
                  <h3>{this.props.title}</h3>
                </div>
              </div>
            </div>
            <div className="items-form mb0">
              <div className="rows mb10">
                <Text className="col-25" label="Cơ quan đã giải quyết:" value={this.props.coQuanDaGiaiQuyetDonThu || ''}/>
                <Text className="col-25" label="Số văn bản:" value={this.props.soVanBanDaGiaiQuyet}/>
                <Text className="col-25" label="Ngày ban hành:" value={moment(this.props.ngayBanHanhVanBanDaGiaiQuyet).format("DD/MM/YYYY")}/>
              </div>
            </div>
            <div className="items-form white-table mb20">
              <div className="rows">
                <div className="col-12">
                  <DataTable
                    header = {header.detailReceptionPeriodical.attach}
                    dataList = {this.props.listTaiLieuVanThuBlockCoQuanDaGiaiQuyet}
                    hidePagination={true}>
                    <RowItemListAttachReceptionPeriodical/>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ThongTinCoQuanDaGiaiQuyet.defaultProps = {
  coQuanDaGiaiQuyetDon: {},
  thamQuyenGiaiQuyetInfo: {},
  hinhThucGiaiQuyetInfo: {},
  soVanBanDaGiaiQuyet: '',
  ngayBanHanhVanBanDaGiaiQuyet: '',
  listTaiLieuVanThuBlockCoQuanDaGiaiQuyet: []
}

export default ThongTinCoQuanDaGiaiQuyet;



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/ThongTinCoQuanDaGiaiQuyet.jsx